var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    [
      _c(
        "leo-dialog",
        { attrs: { show: _vm.isShow, persistence: "", maxWidth: "704px" } },
        [
          _c(
            "leo-button",
            {
              staticClass:
                "leo-bg-white leo-absolute leo-top-0 leo-right-0 leo-mt-xs leo-mr-xs leo-button leo-button--type-fab",
              attrs: { fab: "" },
              on: {
                click: function ($event) {
                  return _vm.$emit("on-close")
                },
              },
            },
            [
              _c("leo-icon", {
                attrs: {
                  type: "close",
                  size: "md",
                  width: "12px",
                  height: "12px",
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "leo-m-auto" }, [
            _c(
              "div",
              {
                staticClass: "leo-text-lg leo-text-secondary leo-font-semibold",
              },
              [_vm._v(" " + _vm._s(_vm.contactProps.heading) + " ")]
            ),
            _c("div", { staticClass: "leo-flex leo-flex-col leo-pt-md" }, [
              _c("div", { staticClass: "leo-text-md leo-text-accent" }, [
                _vm._v(" " + _vm._s(_vm.contactProps.subheading) + " "),
              ]),
              _c(
                "div",
                {
                  staticClass:
                    "leo-flex leo-flex-row leo-justify-between leo-py-sm leo-px-md",
                  on: { click: _vm.onClickCallNumber },
                },
                [
                  _c(
                    "div",
                    [
                      _c("leo-icon", {
                        attrs: { color: "primary", type: "call" },
                      }),
                      _c(
                        "span",
                        {
                          class: [
                            "leo-pl-xs",
                            "leo-text-primary",
                            "leo-text-sm",
                            "tablet:leo-text-md",
                            "leo-font-semibold",
                            _vm.isDesktopChannel ? "" : "leo-cursor-pointer",
                          ],
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.isGELS
                                  ? _vm.contactProps.callNumberSG
                                  : _vm.contactProps.callNumberMY
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "leo-flex leo-flex-row leo-justify-between leo-py-sm leo-px-md",
                  on: { click: _vm.onClickEmail },
                },
                [
                  _c(
                    "div",
                    [
                      _c("leo-icon", {
                        attrs: { color: "primary", type: "email" },
                      }),
                      _c(
                        "span",
                        {
                          staticClass:
                            "leo-pl-xs leo-text-primary leo-text-sm tablet:leo-text-md leo-font-semibold leo-cursor-pointer",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.isGELS
                                  ? _vm.contactProps.emailSG
                                  : _vm.contactProps.emailMY
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }